import { Alert, Button, Tooltip } from "antd";

import { MAX_BULK_MARKS } from "./medicalReview";

export default function ReviewBulkActionBar({
  selectedCount,
  filteredCount,
  marking,
  selectingAll,
  onMarkSelected,
  onClearSelection,
}: {
  selectedCount: number;
  /** Records matching the filters now applied to the table, across all pages. */
  filteredCount: number;
  marking: boolean;
  selectingAll: boolean;
  onMarkSelected: () => void;
  onClearSelection: () => void;
}) {
  // Selecting everything is the column's header checkbox; this bar only
  // reports what is selected and acts on it.
  if (selectedCount === 0 && !selectingAll) return null;

  const overCap = filteredCount > MAX_BULK_MARKS;

  return (
    <Alert
      type="info"
      className="[&_.ant-alert-message]:w-full"
      message={
        <div className="flex flex-wrap items-center justify-between gap-3">
          {/* The cap is stated rather than silently applied, but as a
              tooltip: selecting 500 of 1,200 without saying so would be a
              quiet truncation. */}
          <Tooltip
            title={
              overCap
                ? `${MAX_BULK_MARKS} is the most that can be reviewed at once, of ${filteredCount} matching`
                : ""
            }
          >
            <span className="text-sm text-[#2B4752]">
              {selectingAll ? "Selecting…" : `${selectedCount} selected`}
              {overCap && !selectingAll ? " (max)" : ""}
            </span>
          </Tooltip>
          <div className="flex flex-wrap items-center gap-2">
            <Button size="small" onClick={onClearSelection}>
              Clear selection
            </Button>
            <Button
              size="small"
              type="primary"
              loading={marking}
              disabled={selectedCount === 0}
              onClick={onMarkSelected}
            >
              Mark {selectedCount} reviewed
            </Button>
          </div>
        </div>
      }
    />
  );
}
